/**
 * SEO utility: injects a <script type="application/ld+json"> tag into <head>
 * and returns a cleanup function that removes it.
 */
export function injectJsonLd(id: string, data: object | object[]): () => void {
  const existing = document.getElementById(id);
  if (existing) existing.remove();

  const script = document.createElement('script');
  script.id = id;
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);

  return () => {
    const el = document.getElementById(id);
    if (el) el.remove();
  };
}

/** Updates document.title */
export function setDocumentTitle(title: string): void {
  document.title = title;
}

/** Updates <meta name="description"> content */
export function setMetaDescription(description: string): void {
  const meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
  if (meta) {
    meta.content = description;
  } else {
    const newMeta = document.createElement('meta');
    newMeta.name = 'description';
    newMeta.content = description;
    document.head.appendChild(newMeta);
  }
}

/** Updates <link rel="canonical"> href */
export function setCanonical(url: string): void {
  const link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (link) {
    link.href = url;
  }
}
